import { Pulse, PulsesList } from "@/app/types"

const BASE_API_URL = process.env.API_CMS_URL as string

// ########## Pulses API ##########
export async function apiv2_getPulses(): Promise<PulsesList | null> {
  try {
    const response = await fetch(`${BASE_API_URL}/api/cms/pulse`)

    const jsonResponse = await response.json()

    // validate the response structure, pulses count, and that all pulses have a valid id
    const count: number = "count" in jsonResponse ? jsonResponse.count : -1
    const pulseList: PulsesList =
      "pulseList" in jsonResponse ? jsonResponse.pulseList : []
    if (
      Array.isArray(pulseList) &&
      pulseList.length == count &&
      pulseList.every((pulse) => pulse?.key)
    ) {
      return pulseList
    }
    return null
  } catch (error) {
    console.error("Error fetching pulses:", error)
    return null
  }
}
export async function apiv2_getPulse(key: string): Promise<Pulse | void> {
  try {
    const response = await fetch(`${BASE_API_URL}/api/cms/pulse/${key}`)

    const jsonResponse = await response.json()
    return jsonResponse
  } catch (error) {
    console.error("Error fetching pulse:", error)
  }
}
